import { css } from "@linaria/core";
import React from "react";
import { colors, spacings } from "@ui/Theme";
import Text from "@ui/Text";
import t from "../../../../../i18n";
import type { Quantity } from "../../../../../api/useQuantities";
import formatNumber from "@ui/i18n/formatNumber";
import Evolution from "./Evolution";

const StatisticAverageLosses = ({
  performanceIndicator,
  meanLosses,
  meanMeasuredLosses,
  previousMeanLosses,
}: {
  performanceIndicator: Quantity;
  meanLosses: number;
  meanMeasuredLosses: number;
  previousMeanLosses: number | null;
}) => {
  const meanPercent = (meanLosses / meanMeasuredLosses) * 100;

  return (
    <>
      <div className={statisticAverageLosses}>
        <Text type="h2">
          {formatNumber(meanLosses, { precision: 1, unit: performanceIndicator?.unit ?? "-" })}
        </Text>
        <Text>
          {t("project.fault_event.live.widget.average_losses.value.description", {
            percent: formatNumber(meanPercent, { precision: 1 }),
            total: formatNumber(meanMeasuredLosses, { precision: 1 }),
            unit: performanceIndicator?.unit ?? "-",
          })}
        </Text>
      </div>
      {previousMeanLosses && (
        <Evolution
          mean={meanLosses}
          previousMean={previousMeanLosses}
          performanceIndicator={performanceIndicator}
        />
      )}
    </>
  );
};

//#region CSS
const statisticAverageLosses = css`
  display: flex;
  align-items: baseline;
  gap: ${spacings.xs};
  &:last-child {
    color: ${colors.carbon800};
  }
  padding-bottom: ${spacings.xxs};
`;
//#endregion CSS

export default StatisticAverageLosses;
